export const RING_GROUP_BULK_ADD_USERS_TYPE_WATCHER = 'watcher';
export const RING_GROUP_BULK_ADD_USERS_TYPE_CONNECTED = 'connected';

